export default __webpack_public_path__ + "static/media/sostenibilidad.48187681.png";